import React from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import { formatNumber } from "../../../util/NumberFormatter";

const TOTAL_SUPPLY = 22;

function CharacterMini({ characterName, bestWeapon }) {
  const characterImgSrc = `/img/character/${characterName}.png`;
  const weaponImgSrc = `/img/weapon_skill/${bestWeapon}.png`;

  return (
    <div style={{
      position: 'relative',
      width: '28px',
      height: '28px',
      flexShrink: 0
    }}>
      <div style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        backgroundColor: '#d6d6d6',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <img
          src={characterImgSrc}
          alt={characterName}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <img
        src={weaponImgSrc}
        alt={bestWeapon}
        style={{
          position: 'absolute',
          bottom: '-2px',
          right: '-6px',
          width: '14px',
          height: '14px',
          borderRadius: '50%',
          backgroundColor: '#323232',
          padding: '2px',
          border: '1px solid #4A4A4A'
        }}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
}

export default function StatByGame({ data, loading }) {
  const columns = [
    {
      title: 'GameID',
      dataIndex: 'gameId',
      key: 'gameId',
      align: 'center',
      sorter: (a, b) => a.gameId - b.gameId
    },
    {
      title: '등수',
      dataIndex: 'gameRank',
      key: 'gameRank',
      align: 'center',
      sorter: (a, b) => a.gameRank - b.gameRank
    },
    {
      title: '플레이어',
      key: 'players',
      render: (_, record) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {record.statsByCharacter.map((char) => (
            <div key={char.nickname} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <CharacterMini characterName={char.characterName} bestWeapon={char.bestWeapon} />
              <div style={{ lineHeight: 1.3 }}>
                <div style={{ fontWeight: 'bold' }}>{char.nickname}</div>
                <div style={{ fontSize: '0.85em' }}>
                  {formatNumber(char.damage)} [{(char.damage / char.totalTime).toFixed(2)}]
                </div>
              </div>
            </div>
          ))}
        </div>
      )
    },
    {
      title: '게임 시작 시각',
      dataIndex: 'startDtm',
      key: 'startDtm',
      align: 'center',
      sorter: (a, b) => dayjs(a.startDtm).valueOf() - dayjs(b.startDtm).valueOf(),
      render: (startDtm) => dayjs(startDtm).format('YYYY-MM-DD HH:mm')
    },
    {
      title: '플레이 시간',
      dataIndex: 'totalTime',
      key: 'totalTime',
      align: 'center',
      sorter: (a, b) => a.totalTime - b.totalTime,
      render: (totalTime) => `${Math.floor(totalTime / 60)}분 ${totalTime % 60}초`
    },
    {
      title: '채집물',
      children: [
        {
          title: '운석',
          dataIndex: ['earnedItem', 'meteor'],
          key: 'meteor',
          align: 'center'
        },
        {
          title: '생명의 나무',
          dataIndex: ['earnedItem', 'treeOfLife'],
          key: 'treeOfLife',
          align: 'center'
        },
        {
          title: '알파 미스릴',
          dataIndex: ['earnedItem', 'alpha'],
          key: 'alpha',
          align: 'center'
        },
        {
          title: '오메가 포스코어',
          dataIndex: ['earnedItem', 'omega'],
          key: 'omega',
          align: 'center'
        },
        {
          title: '위클라인',
          dataIndex: ['earnedItem', 'wickline'],
          key: 'wickline',
          align: 'center'
        },
        {
          title: '보라박스',
          dataIndex: ['earnedItem', 'purpleBox'],
          key: 'purpleBox',
          align: 'center'
        },
        {
          title: '빨간 박스',
          dataIndex: ['earnedItem', 'redBox'],
          key: 'redBox',
          align: 'center'
        },
        {
          title: '총합',
          key: 'total',
          align: 'center',
          sorter: (a, b) => {
            const ta = Object.values(a.earnedItem).reduce((acc, val) => acc + val, 0);
            const tb = Object.values(b.earnedItem).reduce((acc, val) => acc + val, 0);
            return ta - tb;
          },
          render: (_, record) => {
            const total = Object.values(record.earnedItem).reduce((acc, val) => acc + val, 0);
            return (
              <span>
                <div>{total}</div>
                <div style={{ fontSize: '0.77em' }}>
                  ({(total * 100 / TOTAL_SUPPLY).toFixed(2)}%)
                </div>
              </span>
            );
          }
        }
      ]
    }
  ];

  return (
    <Table
      className='table-wrapper-with-border'
      pagination={false}
      dataSource={data}
      columns={columns}
      loading={loading}
      rowKey="gameId"
      scroll={{ x: 'max-content' }}
    />
  );
}
